import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=32c97ac7&"
import script from "./Calendar.vue?vue&type=script&lang=ts&"
export * from "./Calendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
installComponents(component, {VCalendar})
